import React, { useCallback, useState } from 'react';
import { Observable } from 'rxjs';
import { useTranslation } from 'react-i18next';
import OptionModal from '../../../../components/modals/option-modal';

export default function useRemove(
  content: string = 'pages.crop.vaad_liz_reports_v2.remove_modal.content'
) {
  const { t } = useTranslation();
  const [modal, setModal] = useState<React.ReactElement | null>(null);

  const confirmRemove = useCallback(
    (
      id: string,
      onRemove: (id: string) => Observable<any>,
      onComplete = () => {}
    ) => {
      const handleRemove = () => {
        setModal(null);
        onRemove(id).subscribe({ complete: onComplete });
      };

      setModal(
        <OptionModal
          content={<p>{t(content)}</p>}
          buttons={[
            {
              title: t('pages.crop.vaad_liz_reports_v2.remove_modal.ok'),
              name: 'yes',
              value: 'yes',
            },
            {
              title: t('pages.crop.vaad_liz_reports_v2.remove_modal.cancel'),
              name: 'no',
              value: 'no',
            },
          ]}
          onChoice={(choice) => {
            if (choice === 'yes') {
              handleRemove();
            } else {
              onComplete();
              setModal(null);
            }
          }}
          onClose={() => {
            onComplete();
            setModal(null);
          }}
        />
      );
    },
    [content, t]
  );

  return { confirmRemove, modal };
}
